import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
import { variant } from 'styled-system';
import ThemeUtilities from '../../../theme/ThemeUtilities';
import { ToggleBaseVariant, ToggleSize, ToggleStateVariant } from './types';
import { fontSmoothing } from '../../../mixins';

export const ToggleWrapper = styled.div<{ isDisabled: boolean }>`
  position: relative;
  cursor: pointer;
  display: inline-block;

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      user-select: none;
      cursor: not-allowed;
    `};
  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Toggle', 'size'))};
`;
export const Track = styled(motion.div).withConfig({
  shouldForwardProp: (prop) => !['baseColor'].includes(prop),
})<{
  baseColor: ToggleBaseVariant;
  size: ToggleSize;
}>`
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Toggle', 'baseColor'))};
  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Toggle', 'size'))};
`;
export const TrackMotion = styled(motion.div).withConfig({
  shouldForwardProp: (prop) => !['colorVariant'].includes(prop),
})<{
  colorVariant: ToggleStateVariant;
}>`
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: border-box;
  transform-origin: left center;
  width: inherit;
  height: inherit;
  border-radius: inherit;

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Toggle', 'color'))};
`;
export const LabelMotion = styled(motion.div).withConfig({
  shouldForwardProp: (prop) => !['textVariant'].includes(prop),
})<{
  size: ToggleSize;
  textVariant: ToggleStateVariant;
}>`
  position: relative;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  ${fontSmoothing};
  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Toggle', 'size'))};

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Toggle', 'text'))};
`;
export const SwitcherMotion = styled(motion.div).withConfig({
  shouldForwardProp: (prop) => !['toggleState'].includes(prop),
})<{
  toggleState: ToggleStateVariant;
}>`
  box-sizing: border-box;

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Toggle', 'switcher'))};
`;
export const SwitcherWrapper = styled(motion.div).withConfig({
  shouldForwardProp: (prop) => !['size'].includes(prop),
})<{
  size: ToggleSize;
}>`
  top: 0;
  left: 0;
  position: absolute;
  display: flex;

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Toggle', 'size'))};
  padding: 0;
`;
